<rappider-list-grid [config]="config"
                    [data]="uiDataUpdateFunctions"
                    [loading]="loading"
                    (listActionClick)="onAddUIDataUpdateFunctionClick()"
                    (columnActionClick)="onDeleteUIDataUpdateFunctionClick($event)"></rappider-list-grid>
